import { MISC_FILES_URL } from '../constants/main';

const trimTrailingSlash = (value) => value?.replace(/\/$/, '');

const buildBaseUrl = (baseUrl) => trimTrailingSlash(baseUrl || '');

const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value || '');

const joinUrl = (base, path) => {
  if (!base) {
    return path;
  }

  if (path?.startsWith('/')) {
    return `${base}${path}`;
  }

  return `${base}/${path}`;
};

/**
 * @param {string} photoPath - S3 key or absolute URL
 * @param {string|number} [cacheBust] - Optional value to append as ?v= to bypass browser cache
 *        (e.g. updatedAt) when the same URL gets new content (e.g. profile photo overwrite)
 */
const getUserPhotoUrl = (photoPath, cacheBust) => {
  if (!photoPath) {
    return null;
  }

  if (isAbsoluteUrl(photoPath)) {
    return cacheBust ? `${photoPath}?v=${encodeURIComponent(cacheBust)}` : photoPath;
  }

  const baseUrl = joinUrl(buildBaseUrl(MISC_FILES_URL), photoPath);
  return cacheBust ? `${baseUrl}?v=${encodeURIComponent(cacheBust)}` : baseUrl;
};

export default getUserPhotoUrl;
